import axios from 'axios';
export default {
  namespaced: true,
  state() {
    return {
      pass_informers: [],
      timer: null
    };
  },
  mutations: {
    set_pass_informers: (state, v) => {
      state.pass_informers = v;
    },
    clear: state => {
      state.pass_informers = [];
    }
  },
  actions: {
    check_pass(context, params) {
      clearTimeout(context.state.timer);
      context.state.timer = setTimeout(() => {
        if (params.locale) {
          return axios
            .post(
              '/1.0/user-passwords/password-policy/check-new',
              {
                password: params.password
              },
              {
                headers: { 'Accept-Language': params.locale }
              }
            )
            .then(r => {
              context.commit('set_pass_informers', r.data.data);
            });
        } else {
          return axios
            .post('/1.0/user-passwords/password-policy/check-new', {
              password: params.password
            })
            .then(r => {
              context.commit('set_pass_informers', r.data.data);
            });
        }
      }, 500);
    }
  },
  getters: {
    pass_informers: state => state.pass_informers
  }
};
